
import React, { useEffect, useState } from 'react';
import { Row, Col, Button, Table } from 'react-bootstrap';
import { DropDown, FieldGroup, TextInput, CurrencyInput, RadioButton, CheckBoxes } from '../../../../../../../../components/form/form';
import ListingService from '../../../../../../../../services/listing-service';
import Loading from '../../../../../../../../components/loading/loading';
import SellingAgentAllocation from './selling-agent-allocation/selling-agent-allocation';
import { PATTERN_ALPHA_NUMERIC_SPACE, PATTERN_ALPHA_NUMERIC_SPACE_DOT, PATTERN_NUMBER_4_DECIMAL } from '../../../../../../../../helpr/constants';

import styles from './issue-participant-form.module.scss';

const CreateIssueParticipantForm = ({ index, curInstitution, securityList, participantFormState, participantRole, saveParticipant}) => {
  const { validate, resetForm, forceSetField, forceSetFieldDynamic, getCheckBoxesProps, getTextFieldProps, getRadioButtonProps } = participantFormState;
  const securityListNames = securityList.map((data,index)=>{return {name: data['prefShortName'], value: index.toString()}});
  const salutations = [ {name: 'Mr.', value: 'Mr.'}, {name: 'Ms.', value: 'Ms.'} ];
  const listingService = new ListingService();

  /*
    Clear form for creating new participant
    (Using the validation hook RESET action)
    ex - form field clear exception
  */
  const clearForm = (ex) => {
    resetForm(ex);
    forceSetFieldDynamic('allocation', [{
      securityIndex: '',
      amount: ''
    }]);
  }

  /*
    Form Option in Creating an Issue Participant
    participantObjectList - list of participants that can be added or modified
    formDisabledfFlag - toggle form disabled/enabled
  */
  const [ formOption, setFormOption] = useState({
    institutionList: [],
    participantObjList: [],
    primaryContactList: [],
    institutionName: '',
    primaryContact: '',
    buttonState: 'ADD',
    formDisabledFlag: true,
    loading: false
  });

  /*
    Run the service that get's the participant list
    Initialize the formOption
  */
  useEffect(()=>{
    const initializeInstitutionNames = async (role) => {
      if( role !== 'Custom' ){ forceSetField('role', role) }
      let result = await listingService.getParticipantInstitutions(role, curInstitution);
      let institutionList = [ { name: 'NEW', value: 'NEW' } ];
      const participantKeys = Object.keys(result['participants']);

      for( var index in participantKeys ) {
        institutionList.push({
          name: participantKeys[index],
          value: participantKeys[index]
        })
      }
      setFormOption(prev=>({
        ...prev,
        institutionList: institutionList,
        participantObjList: result['participants'],
        buttonState: 'ADD',
        institutionName: '',
        primaryContact: '',
        formDisabledFlag: ( role !== 'Custom' ),
        loading: false
      }))
    }

    // Start Loading Service values and toggle participant loading flag
    if( participantRole !== '' ){
      clearForm();
      setFormOption(prev=>({...prev, loading: true}))
      initializeInstitutionNames(participantRole);
    }
  },[participantRole]);

  /*
    Select Institution and build up contact list
  */
  const selectInstitutionHandler = (e) => {
    clearForm(['role']);
    const institutionName = e.target.value;
    if( institutionName !== 'NEW' ) {
      forceSetField('institutionName', institutionName);
      const selectedContactList = formOption.participantObjList[institutionName];
      let array = [ { name: 'NEW', value: 0 } ];
      for(let index in selectedContactList){
        array.push({
          name: selectedContactList[index].primaryContactNameStr,
          value: parseInt(index) + 1
        })
      }
      setFormOption(prev=>({
        ...prev,
        primaryContactList: array,
        institutionName: institutionName,
        primaryContact: ''
      }))
    } else {
      setFormOption(prev=>({
        ...prev,
        institutionName: institutionName,
        primaryContact: '',
        formDisabledFlag: false,
        buttonState: 'ADD'
      }))
    }
  }


  const addParticipant = () => {
    const { formState, isFormValid } = validate();
    if( isFormValid ){
      clearForm();
      saveParticipant(index, formState);
    } else {
      console.log(formState);
    }
  }

  /*
    Select Primary Contact to enable and auto fill the participant form
  */
  const selectPrimaryContact = (e) => {
    const contactIndex = e.target.value;
    if( parseInt(contactIndex) === 0 ) { // New Contact
      clearForm(['role', 'institutionName']);
      setFormOption(prev=>({
        ...prev,
        formDisabledFlag: false,
        buttonState: 'ADD'
      }))
    }
    else {
      setFormOption(prev=>({
        ...prev,
        formDisabledFlag: true,
        buttonState: 'EDIT'
      }))
      setFormValue(formOption.participantObjList[formOption.institutionName][parseInt(contactIndex) - 1]);
    }
    setFormOption(prev=>({
      ...prev,
      primaryContact: contactIndex
    }))
  }

  /*
    Auto Fill-Up Form after primary contact selection
  */
 const setFormValue = (formValue) => {
    forceSetField('role', formValue['role']);
    forceSetField('primaryContactLastName', formValue.primaryContact['lastName']);
    forceSetField('primaryContactFirstName', formValue.primaryContact['firstName']);
    forceSetField('primaryContactMiddleInitial', formValue.primaryContact['middleInitial']);
    forceSetField('addressStreetAddress', formValue.address['street']);
    forceSetField('addressDistrictOrTown', formValue.address['districtOrTown']);
    forceSetField('addressCity', formValue.address['city']);
    forceSetField('addressStateProvinceRegion', formValue.address['stateProvinceRegion']);
    forceSetField('addressCountry', formValue.address['country']);
    forceSetField('addressZipCode', formValue.address['zipCode']);
    forceSetField('preferredSalutation', formValue['preferredSalutation']);
    forceSetField('title', formValue['title']);
    forceSetField('telephoneNumber', formValue['telephoneNumber']);
    forceSetField('emailAddress', formValue['emailAddress']);
  }

  const enableEdit = (edit) => {
    setFormOption(prev=>({
      ...prev,
      formDisabledFlag: !edit ,
      buttonState: 'SAVE'
    }));
  }

  const saveParticipantInfo = () => {
    setFormOption(prev=>({
      ...prev,
      formDisabledFlag: true ,
      buttonState: 'EDIT'
    }))
  }


  const renderActionButtons = () => {
    switch(formOption.buttonState){
      case 'ADD': {
        return (
          <Row className={styles['btn-actions']}>
            <Button disabled={ formOption.primaryContact === '' && formOption.institutionName !== 'NEW' && participantRole !== 'Custom' } onClick={()=>addParticipant()}>ADD</Button>
          </Row>
        )
      }
      case 'EDIT': {
        return (
          <Row className={styles['btn-actions']}>
            <Button className="btn-secondary" onClick={()=>enableEdit(true)}>EDIT</Button>
            <Button onClick={()=>saveParticipantInfo()} disabled>SAVE</Button>
            <Button onClick={()=>addParticipant()}>ADD</Button>
          </Row>
        )
      }
      case 'SAVE': {
        return (
          <Row className={styles['btn-actions']}>
            <Button className="btn-secondary" onClick={()=>enableEdit(true)} disabled>EDIT</Button>
            <Button onClick={()=>saveParticipantInfo()}>SAVE</Button>
            <Button disabled>ADD</Button>
          </Row>
        )
      }
    }
  }

  const renderInstitutionFields = () => {
    switch( participantRole ){
      case 'Custom': {
        return (
          <>
            <Row>
              <Col sm={6} lg={4}>
                <TextInput inputProps={getTextFieldProps('role')}>
                  Role:*
                </TextInput>
              </Col>
            </Row>
            <Row>
              <Col sm={6} lg={4}>
                <TextInput inputProps={getTextFieldProps('institutionName')}>
                  Institution Name:*
                </TextInput>
              </Col>
            </Row>
          </>
        )
      }
      default: {
        return (
          <>
            <Row>
              <Col sm={6} lg={4}>
                <DropDown
                  inputProps={{value: formOption.institutionName, onChange: selectInstitutionHandler}}
                  values={formOption.institutionList}
                  disabled={participantRole === '' || formOption['loading']}>
                  Institution Name:*
                </DropDown>
              </Col>
            </Row>
            { formOption.institutionName === 'NEW' && (
              <Row>
                <Col sm={6} lg={4}>
                  <TextInput inputProps={getTextFieldProps('institutionName')}>
                    New Institution Name:*
                  </TextInput>
                </Col>
              </Row>
            ) }
            { formOption.institutionName !== '' && formOption.institutionName !== 'NEW' && (
              <Row>
                <Col sm={6} lg={4}>
                  <DropDown
                    inputProps={{value: formOption.primaryContact, onChange: selectPrimaryContact}}
                    values={formOption.primaryContactList}>
                    Primary Contact:*
                  </DropDown>
                </Col>
              </Row>
            )}
          </>
        )
      }
    }
  }

  /*
    Render Participant Info Detail Form
    Set Loading Flag to true when doing an API call
  */
  const renderForm = () => {
    return (
      <>
        { renderInstitutionFields() }
        <Row className="mt-2">
          <Col sm={12} lg={10}>
            <FieldGroup header="PRIMARY CONTACT NAME">
              <Row>
                <Col sm={6} lg={4}>
                  <TextInput inputProps={getTextFieldProps('primaryContactLastName')} placeholder="Last Name" disabled={formOption.formDisabledFlag} maxLength="75" pattern={PATTERN_ALPHA_NUMERIC_SPACE}/>
                </Col>
                <Col sm={6} lg={4}>
                  <TextInput inputProps={getTextFieldProps('primaryContactFirstName')} placeholder="First Name" disabled={formOption.formDisabledFlag} maxLength="70" pattern={PATTERN_ALPHA_NUMERIC_SPACE}/>
                </Col>
                <Col sm={6} lg={4}>
                  <TextInput inputProps={getTextFieldProps('primaryContactMiddleInitial')} placeholder="Middle Initial" maxLength="5" disabled={formOption.formDisabledFlag} pattern={PATTERN_ALPHA_NUMERIC_SPACE_DOT}/>
                </Col>
              </Row>
            </FieldGroup>
          </Col>
        </Row>
        <Row>
          <Col sm={12} lg={8}>
            <Row>
              <Col sm={6} lg={6}>
                <RadioButton inputProps={getRadioButtonProps('preferredSalutation')} data={salutations} disabled={formOption.formDisabledFlag}>
                  Preferred Salutation:*
                </RadioButton>
              </Col>
              <Col sm={6} lg={6}>
                <TextInput inputProps={getTextFieldProps('title')} disabled={formOption.formDisabledFlag} maxLength="150" pattern={PATTERN_ALPHA_NUMERIC_SPACE}>
                  Title/Designation:*
                </TextInput>
              </Col>
            </Row>
          </Col>
        </Row>
        {participantRole === 'SellingAgent' && (
          <>
            <SellingAgentAllocation securityList={securityList} participantFormState={participantFormState}/>
          </>
        )}
        {participantRole === 'MarketMaker' && (
          <>
            <Row>
              <Col>
                <CheckBoxes inputProps={getCheckBoxesProps('securitySubscription')} values={securityListNames}>
                  Security:*
                </CheckBoxes>
              </Col>
            </Row>
          </>
        )}
        <Row>
          <Col sm={12} lg={8}>
            <FieldGroup header="MAILING ADDRESS:*">
              <Row>
                <Col>
                  <TextInput inputProps={getTextFieldProps('addressStreetAddress')} placeholder="House/Lot/Block/Unit No., Floor & Building, Subdivision/Barangay/Vilage" disabled={formOption.formDisabledFlag} maxLength="50"/>
                </Col>
              </Row>
              <Row>
                <Col sm={6} lg={6}>
                  <TextInput inputProps={getTextFieldProps('addressDistrictOrTown')} placeholder="District/Town" disabled={formOption.formDisabledFlag} maxLength="50"/>
                </Col>
                <Col sm={6} lg={6}>
                  <TextInput inputProps={getTextFieldProps('addressCity')} placeholder="City" disabled={formOption.formDisabledFlag} maxLength="50"/>
                </Col>
              </Row>
              <Row>
                <Col sm={6} lg={6}>
                  <TextInput inputProps={getTextFieldProps('addressStateProvinceRegion')} placeholder="State/Province/Region" disabled={formOption.formDisabledFlag} maxLength="50"/>
                </Col>
                <Col sm={6} lg={6}>
                  <TextInput inputProps={getTextFieldProps('addressCountry')} placeholder="Country" disabled={formOption.formDisabledFlag} maxLength="50"/>
                </Col>
              </Row>
              <Row>
                <Col sm={6} lg={6}>
                  <TextInput inputProps={getTextFieldProps('addressZipCode')} placeholder="Zip Code" disabled={formOption.formDisabledFlag} maxLength="50"/>
                </Col>
              </Row>
            </FieldGroup>
          </Col>
        </Row>
        <Row className="mb-5">
          <Col sm={12} lg={8}>
            <Row>
              <Col sm={6} lg={6}>
                <TextInput inputProps={getTextFieldProps('telephoneNumber')} disabled={formOption.formDisabledFlag} maxLength="30">
                  Telephone Number:*
                </TextInput>
              </Col>
              <Col sm={6} lg={6}>
                <TextInput inputProps={getTextFieldProps('emailAddress')} disabled={formOption.formDisabledFlag}>
                  Email Address:*
                </TextInput>
              </Col>
            </Row>
          </Col>
        </Row>
      </>
    )
  }

  return (
    <>
      { formOption.loading? <Row className={styles['content-buffer']}><Loading/></Row> : renderForm() }
      { renderActionButtons() }
    </>
  )
}

export default CreateIssueParticipantForm;





